/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const bankDataTranslations = {
  iban: {
    label: "IBAN"
  }
};

export default bankDataTranslations;
